import client from './api/client';

export const login = async (login, password) => {
    const response = await client.post('/auth/login', { login, password });
    return response.data;
};

export const logout = async () => {
    try {
        await client.post('/auth/logout', {});
    } catch (error) {
        console.error('Logout failed:', error);
    }
};

export const checkAuth = async () => {
    const response = await client.get('/auth/check');
    return response.data;
};
